// !This component decides if we should show the old InsilicoPredictions Component or the new one
import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import InSilicoPredictionsScoresBased from "./scoresBasedInsilicoPredictions/InSilicoPredictionsScoresBased";
import InSilicoPredictions from "./InSilicoPredictions";
import { isThaliaVersionSmallerThanElevenPointFour } from "../../../../state/selectors/ACMGComponent.selectors";

const InsilicoPredictionsWrapper = ({ shouldShowNewComponent }) => {
  if (shouldShowNewComponent) return <InSilicoPredictionsScoresBased />;
  return <InSilicoPredictions />;
};

const mapStateToProps = (state) => ({
  shouldShowNewComponent: !isThaliaVersionSmallerThanElevenPointFour(state),
});

InsilicoPredictionsWrapper.propTypes = {
  shouldShowNewComponent: PropTypes.bool,
};

InsilicoPredictionsWrapper.defaultProps = {
  shouldShowNewComponent: false,
};
export default connect(mapStateToProps)(InsilicoPredictionsWrapper);
